<template>
  <ul
    class="TheFooterList footer-list"
  >
    <li
      v-for="(child, index) in list"
      :key="index"
      class="footer-list__item"
    >
      <router-link
        v-if="child.currentApp"
        class="footer-list__item-link link-with-opacity"
        :to="child.path"
      >
        <span>{{ child.name }}</span>
      </router-link>
      <a
        v-else-if="child.path.startsWith('/')"
        class="footer-list__item-link link-with-opacity"
        :href="child.path"
      >
        <span>{{ child.name }}</span>
      </a>
      <a
        v-else
        class="footer-list__item-link link-with-opacity"
        :href="child.path"
        target="_blank"
        rel="noopener"
      >
        <span>{{ child.name }}</span>
      </a>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TheFooterList',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
});
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.footer-list
  list-style-type: none
  padding-left: 0
  margin-left: 0
  display: flex
  flex-direction: row
  justify-content: space-between
  flex-wrap: wrap
  &__item
    width: calc(50% - 46px)
    flex-shrink: 0
    margin-bottom: 20px
  &__item-link
    font-size: 14px
    line-height: 20px
    display: inline
    +font(600)
    +mt(.2s)
    &:hover
      opacity: 0.7
    &:active
      opacity: 0.5
</style>
